import { render } from "./HeroBannerContent.vue?vue&type=template&id=cd2de73e&scoped=true&ts=true"
import script from "./HeroBannerContent.vue?vue&type=script&lang=ts"
export * from "./HeroBannerContent.vue?vue&type=script&lang=ts"

import "./HeroBannerContent.vue?vue&type=style&index=0&id=cd2de73e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd2de73e"]])

export default __exports__